// extracted by extract-css-chunks-webpack-plugin
module.exports = {"logs-description":"activity-logs__logs-description--gfCeA","logsDescription":"activity-logs__logs-description--gfCeA"};